import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[ecpRefreshLink]',
  standalone: false,
})
export class RefreshItemLinkDirective {
  constructor(public element: ElementRef) {}
}
